import * as React from "react";

import Button from "@material-ui/core/Button/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import TextField from "@material-ui/core/TextField";

import { CyNumber } from "../../../../utilities/number";

import { Transition } from "../../../../components";

class HouseholdCreatePortfolioDialog extends React.Component {
  state = {
    name: "",
    initialInvestment: "",
    isFormValid: {
      status: false,
      message: "",
    },
  };

  handleClose() {
    this.setState({
      name: "",
      initialInvestment: "",
      isFormValid: { status: false, message: "" },
    });
    this.props.onCancel && this.props.onCancel();
  }

  updateInitialInvestment(value) {
    // ensure that it does not exceed household initial investment
    const { CurrencyParser } = CyNumber;
    this.setState(
      { initialInvestment: CurrencyParser(value) },
      this.checkFormValid
    );
  }

  /*
    Check if the name / initial statement form are valid*
    and update the state of status / message of isFormValid

    *Valid
    - Non empty string on the name / initial investment fields
    - Initial investment amount is bigger than minimum (50,000)
  */
  checkFormValid = () => {
    const { name, initialInvestment } = this.state;
    if (!this.checkValidStr(name)) {
      this.setState({
        isFormValid: {
          status: false,
          message: "Please give the portfolio a name",
        },
      });
    } else if (!this.checkValidStr(initialInvestment)) {
      this.setState({
        isFormValid: {
          status: false,
          message: "Please enter an investment amount",
        },
      });
    } else if (initialInvestment < 10000) {
      this.setState({
        isFormValid: {
          status: false,
          message: "The minimum account is $10,000",
        },
      });
    } else {
      this.setState({ isFormValid: { status: true, message: "" } });
    }
  };

  /* Check if the value is non-empty */
  checkValidStr = (v) => v.toString().trim() !== "";

  /* Handle input for the form on Add New Portfolio modal */
  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.checkFormValid);
  };

  render() {
    const { household, isOpen, onCreate, classes } = this.props;
    const { isFormValid, initialInvestment } = this.state;
    const { CurrencyFormatter } = CyNumber;
    const maxInvestment = household.householdDetail.initialInvestment;
    return (
      <Dialog
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => this.handleClose()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          Start a new portfolio
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Please choose a name and investment amount for this portfolio.
          </DialogContentText>
          <TextField
            style={{ display: "block", marginTop: "0.5em" }}
            label="Portfolio Name"
            name="name"
            type="text"
            value={this.state.name}
            onChange={this.handleInput}
            required={true}
            data-cy="household.addPortfolio.dialog.portfolioName"
          />
          <TextField
            style={{ display: "block", marginTop: "0.5em" }}
            label="Investment Amount"
            placeholder={CurrencyFormatter(maxInvestment)}
            value={
              initialInvestment ? CurrencyFormatter(initialInvestment) : ""
            }
            onChange={(e) => this.updateInitialInvestment(e.target.value)}
            required={true}
            data-cy="household.addPortfolio.dialog.initialInvestment"
          />

          {!isFormValid.status && (
            <span className={classes.validationMessage}>
              {isFormValid.message}
            </span>
          )}
        </DialogContent>
        <DialogActions style={{ paddingRight: "1em", paddingBottom: "1em" }}>
          <Button
            className={classes.btn}
            onClick={() => this.handleClose()}
            size="small"
          >
            Cancel
          </Button>
          <Button
            className={classes.btn}
            onClick={() => onCreate(this.state)}
            variant="contained"
            color="primary"
            size="small"
            disabled={!isFormValid.status}
            data-cy="household.addPortfolio.dialog.submit"
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default HouseholdCreatePortfolioDialog;



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/CreatePortfolioDialog/index.jsx